import React from 'react';
import { Circle, Path, SVG } from 'web-common/src/shared/design-system/Utilities';
import { Colors } from 'web-common/src/shared/styles/colors';

export const Plus = ({
  circleFill = Colors.WHITE,
  symbolFill = Colors.BLACK,
  ...svgProps
}: React.SVGProps<SVGSVGElement> & { circleFill?: string; symbolFill?: string }) => (
  <SVG height={24} width={24} viewBox={'0 0 24 24'} {...svgProps}>
    <Circle cx='12' cy='12' r='12' fill={circleFill} />
    <Path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H13V8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V11H8C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H11V16Z'
      fill={symbolFill}
    />
  </SVG>
);
